import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { Lookup } from '@app/modules/lookup/models/lookup.model';
import { LookupService } from '@app/modules/lookup/services/lookup.service';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import moment from 'moment';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { EmploymentRecordDiscipline } from '../../models/employment-record-discipline.model';
import { EmploymentRecordDisciplineService } from '../../services/employment-record-discipline.service';

@Component({
  selector: 'app-employment-record-discipline-dialog',
  templateUrl: './employment-record-discipline-dialog.component.html',
  styleUrls: ['./employment-record-discipline-dialog.component.scss']
})
export class EmploymentRecordDisciplineDialogComponent implements OnInit {
  form: UntypedFormGroup;
  employmentRecordId: any;
  employeeId: any;
  disciplineId: any;
  isLoading: boolean;
  employmentRecordDiscipline: EmploymentRecordDiscipline;
  actionOptions: Observable<Lookup[]>;
  reasonOptions: Observable<Lookup[]>;

  constructor(
    private fb: UntypedFormBuilder,
    private lookupService: LookupService,
    private overlayService: OverlayService,
    private employmentRecordDisciplinesService: EmploymentRecordDisciplineService,
    private snackbarService: SnackbarService,
    private dialogRef: MatDialogRef<EmploymentRecordDisciplineDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data)
  {
    this.employmentRecordId = data.employmentRecordId;
    this.employeeId = data.employeeId;
    this.disciplineId = data.DisciplineId;
  } 

  ngOnInit(): void {
    this.getLookups();

    this.disciplineId !== null 
      ? this.getEmploymentRecordDiscipline() 
      : this.isLoading = false; 
        this.createForm();
  }

  getEmploymentRecordDiscipline() {
    this.isLoading = true;
    
    this.employmentRecordDisciplinesService.getDiscipline(this.employeeId, this.employmentRecordId, this.disciplineId)
    .pipe(
      finalize(() => this.isLoading = false)
    )
    .subscribe(
      res => {
        this.employmentRecordDiscipline = res;
        this.createForm();
      }
    );
  }

  getLookups() {
    this.actionOptions = this.lookupService.getLookups("/lookup/DISCIPLINE_ACTION");
    this.reasonOptions = this.lookupService.getLookups("/lookup/DISCIPLINE_REASON");
  }

  createForm() {
    this.form = this.fb.group({
      id: [this.employmentRecordDiscipline ? this.employmentRecordDiscipline.id : null],
      effectiveDate: [moment().format()],
      reason: [this.employmentRecordDiscipline && this.employmentRecordDiscipline.reason ? this.employmentRecordDiscipline.reason.id : null],
      action: [this.employmentRecordDiscipline && this.employmentRecordDiscipline.action ? this.employmentRecordDiscipline.action.id : null],
      date: [this.employmentRecordDiscipline ? this.employmentRecordDiscipline.date : null],
      conductedBy: [this.employmentRecordDiscipline ? this.employmentRecordDiscipline.conductedBy : null],
      comments: [this.employmentRecordDiscipline ? this.employmentRecordDiscipline.comments : null],
      changeReason: [''],
      changeReasonComments: ['']
    });
  }

  save(){
    this.overlayService.show();

    this.employmentRecordDisciplinesService.postDiscipline(this.employeeId, this.employmentRecordId, this.form.value)
    .pipe(
      finalize(() => this.overlayService.hide())
    )
    .subscribe(
      (res) => {
        this.snackbarService.openSnackBar('Discipline saved successfully', 'clear', 'success');
        this.dialogRef.close(true);
      },
      err => {
        this.snackbarService.openSnackBar(err, 'clear', 'warn');
      }
    );
  }

  close(){
    this.dialogRef.close();
  }

}


